module.exports = __webpack_public_path__ + "static/media/twitter_440x220.2df33015.png";